import type { Flag } from '@/state/flags/flag-types';
import { useExperiment } from '@/state/experiments/useExperiment';
import { Description } from '../../Experiments/Details/ExperimentInfo/Description';
import { Screenshots } from '../../Experiments/Details/ExperimentInfo/Screenshots';
import { FLAG_COPY } from '../copy';

type FlagBriefProps = { flag: Flag; isEditor: boolean };

const COPY = FLAG_COPY.brief;

/**
 * The flag's Brief: what it is for, in the experiment Brief's own Description card, which the
 * create dialog's description starts. An editor flag also gets the previews of its two sides.
 *
 * The cards save through PUT /experiments/:id and refresh the experiment query, so they read the
 * flag from it (GET /experiments/:id serves a flag too), falling back to the flag page's copy
 * until it arrives. Not the Hypothesis card: its expected mechanisms and similar past tests are
 * about a test's outcome, and nothing a release needs. No PXL or plan either: those rank tests.
 */
export const FlagBrief = ({ flag, isEditor }: FlagBriefProps) => {
  const { experiment } = useExperiment(flag.id);
  const current = experiment ?? flag;

  return (
    <div className="flex flex-col gap-[14px]">
      <Description experiment={current} copy={COPY.description} />
      {isEditor && (
        <Screenshots
          experiment={current}
          copy={COPY.previews}
          // The sides are Off and On here, whatever the variants are called (an editor flag's Off is "Original").
          labelFor={(variant) => (variant.key === 'on' ? FLAG_COPY.create.on : FLAG_COPY.create.off)}
        />
      )}
    </div>
  );
};
